import React from 'react';
// TODO! use that modal from vite as default
export default class ErrorBoundary extends React.Component {
    state = {
        error: undefined,
    };
    componentDidCatch(error) {
        this.setState({ error });
    }
    render() {
        if (this.state.error)
            return this.props.renderError ? this.props.renderError(this.state.error) : React.createElement("h1", null, "App Crashed!");
        return this.props.children;
    }
}
